let tableUtils = {
    initPaginatedDataTable: function (developmentDiv, tableConfig, fixedHeight, sortable) {
        const paginatedTable = developmentDiv.querySelector('.pagination');
        const dataTable = new DataTable(paginatedTable, {
            perPage: tableConfig.itemsPerPage,
            perPageSelect: false,
            searchable: false,
            firstLast: true,
            firstText: visuallyHiddenText(tableConfig.tooltips.firstPage),
            prevText: visuallyHiddenText(tableConfig.tooltips.prevPage),
            pageText: visuallyHiddenText(tableConfig.tooltips.page),
            nextText: visuallyHiddenText(tableConfig.tooltips.nextPage),
            lastText: visuallyHiddenText(tableConfig.tooltips.lastPage),
            fixedHeight: fixedHeight,
            sortable: sortable,
            labels: {
                info: tableConfig.headerTemplateMessage,
            }
        });

        return dataTable;
    },
    initPaginationControlStates: function (dataTable, paginationContainer) {
        let firstPageArrows = () => {
            let lastPrevBtn = paginationContainer.firstElementChild;
            let PAGINATION_CHILDREN = paginationContainer.children;
            let prevBtn = PAGINATION_CHILDREN.item(1);
            if (dataTable.onFirstPage) {
                lastPrevBtn.classList.add('disabled');
                prevBtn.classList.add('disabled');
                lastPrevBtn.setAttribute('tabindex', '-1');
                prevBtn.setAttribute('tabindex', '-1');
                lastPrevBtn.querySelector('a').setAttribute('tabindex', '-1');
                prevBtn.querySelector('a').setAttribute('tabindex', '-1');
            }
        };

        let lastPageArrows = () => {
            let lastChild = paginationContainer.lastChild;
            let secondLast = lastChild.previousSibling;
            if (dataTable.onLastPage) {
                lastChild.classList.add('disabled');
                secondLast.classList.add('disabled');
                lastChild.setAttribute('tabindex', '-1');
                secondLast.setAttribute('tabindex', '-1');
                lastChild.querySelector('a').setAttribute('tabindex', '-1');
                secondLast.querySelector('a').setAttribute('tabindex', '-1');
            }
        };
        dataTable.on('datatable.init', () => {
            firstPageArrows();
        });
        dataTable.on('datatable.page', () => {
            firstPageArrows();
            lastPageArrows();
        });
        dataTable.on('datatable.sort', function (column, direction) {
            firstPageArrows();
        });
    },
    displayFirstPageAfterSort: function (dataTable, tableContainer) {
        let srt_lnk = tableContainer.querySelectorAll('.dataTable-sorter');
        srt_lnk.forEach((lnk) => {
            lnk.addEventListener('click', () => {
                if (dataTable.onFirstPage) {
                    return;
                } else {
                    dataTable.page(1);
                }
            });
        });
    },
    initShowPropertiesButton: function (propertyTableWrapper, showHideButton) {
        if (showHideButton) {
            showHideButton.addEventListener('click', () => {
                propertyTableWrapper.classList.toggle('visible');
                showHideButton.classList.toggle('open-tab');
                showHideButton.setAttribute('aria-expanded',
                    `${(showHideButton.getAttribute('aria-expanded') !== 'true').toString()}`
                );
            });
        }
    }
};